import theme from "../../../../theme";

/**
 * Style object for the sidebar layout container.
 * Arranges all sidebar elements in a vertical stack.
 *
 * @type {import("@mui/system").SxProps}
 */
export const sidebarBox = {
  display: "flex",
  flexDirection: "column",
  gap: "0.5rem",
};

/**
 * Style object for the container of top action buttons.
 * Adds spacing between buttons and below the container.
 *
 * @type {import("@mui/system").SxProps}
 */
export const topButtonContainer = {
  display: "flex",
  flexDirection: "column",
  gap: "0.5rem",
  marginBottom: "1rem",
};

/**
 * Style object for sidebar action buttons ("Relist the Car", "Previous Auction 2").
 * Preserves all original props including padding, color, and hover behavior.
 *
 * @type {import("@mui/system").SxProps}
 */
export const sidebarButton = {
  borderRadius: "0.5rem",
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.text.secondary,
  textTransform: "none",
  fontWeight: 500,
  padding: "0.85rem 1rem",
  fontSize: "0.95rem",
  "&:hover": {
    backgroundColor: theme.palette.primary.dark,
  },
};

/**
 * Style object for the Paper displaying sale information.
 *
 * @type {import("@mui/system").SxProps}
 */
export const saleInfoPaper = {
  padding: "1rem",
  borderRadius: "1rem",
  backgroundColor: theme.palette.background.paper,
};
